module.exports = __webpack_public_path__ + "img/defaultVoucherIco.96a2eea4.png";